<template>
    <div>
        <div
            ref="wrapperRef"
            class="relative h-full"
        >
            <div
                ref="targetRef"
                class="fixed rounded-sm"
            ></div>

            <div
                ref="summaryRef"
                class="w-full rounded-sm pb-12 md:py-12 md:pl-12 lg:fixed"
                data-spec-class="summary"
            >
                <BaseButton
                    v-if="!areMobileDetailsVisible"
                    class="lg:hidden"
                    @click="areMobileDetailsVisible = true"
                >
                    {{ $t('configuratorGeneral.showSummary') }}
                </BaseButton>

                <div
                    :class="{
                        'lg:block': true,
                        hidden: !areMobileDetailsVisible,
                    }"
                >
                    <SummaryGroups :summary-groups="summaryGroups"></SummaryGroups>
                </div>
                <SummaryPrices
                    :monthly-price="monthlyPrice"
                    :setup-price="setupPrice"
                    :summary-groups="summaryGroups"
                ></SummaryPrices>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, onMounted, onBeforeUnmount } from 'vue';
import SummaryGroups from './SummaryGroups.vue';
import SummaryPrices from './SummaryPrices.vue';

defineProps({
    summaryGroups: { type: Array, default: () => [] },
    monthlyPrice: { type: Number, required: true },
    setupPrice: { type: Number, required: true },
});

const areMobileDetailsVisible = ref(false);
const wrapperRef = ref(null);
const summaryRef = ref(null);
const targetRef = ref(null);

const handleScroll = () => {
    if (summaryRef.value && wrapperRef.value && targetRef.value) {
        const wrapperRect = wrapperRef.value.getBoundingClientRect();
        const targetRect = targetRef.value.getBoundingClientRect();
        updateSummaryDimensions();

        if (wrapperRect.bottom <= targetRect.bottom) {
            summaryRef.value.classList.remove('lg:fixed');
            summaryRef.value.classList.add('lg:absolute', 'bottom-0', 'w-full');
        } else {
            summaryRef.value.classList.remove('lg:absolute', 'bottom-0', 'w-full');
            summaryRef.value.classList.add('lg:fixed');
        }
    }
};

const updateSummaryDimensions = () => {
    summaryRef.value.style.width = `${wrapperRef.value.getBoundingClientRect().width}px`;
    targetRef.value.style.height = `${summaryRef.value.getBoundingClientRect().height}px`;
};

const handleDocumentResize = () => {
    updateSummaryDimensions();
};

onMounted(() => {
    if (!user) {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleDocumentResize);
        updateSummaryDimensions();
    }
});

onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', handleDocumentResize);
});

const user = document.querySelector('meta[name="user"]').getAttribute('content') || '';
</script>
